import { Component, OnInit, signal } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CommonBaseClass } from '../../../../shared/classes/common-base-class';
import { HelperService } from '../../../../shared/services/helper.service';
import { environment } from '../../../../../environments/environment';
import { ProgressBarModule } from 'primeng/progressbar';

@Component({
  selector: 'app-profile-completion-modal',
  standalone: true,
  imports: [ButtonModule, ProgressBarModule],
  templateUrl: './profile-completion-modal.component.html',
  styleUrl: './profile-completion-modal.component.scss'
})
export class ProfileCompletionModalComponent extends CommonBaseClass implements OnInit {

  appName = environment.title;
  profileStrengthValue: number = 0;

  constructor(private ref: DynamicDialogRef, private router:Router, helperService: HelperService,
    public config: DynamicDialogConfig
  ) {
    super(helperService);
  }

  ngOnInit(): void {
    this.profileStrengthValue = this.config.data.profileStrengthValue || 0;
  }

  editProfile(): void {
    this.navigateToMainProfile();
    this.ref.close();
  }

  accountSettings(): void {
    this.router.navigateByUrl('/reviewer/settings');
    this.ref.close();
  }

  closeDialog(): void{
    this.ref.close();
  }
}
